'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Trackable = require('../decorators/Trackable');

var _ComponentWithBodyClass = require('../utils/ComponentWithBodyClass');

var _ComponentWithBodyClass2 = _interopRequireDefault(_ComponentWithBodyClass);

var _version = require('../version');

var _version2 = _interopRequireDefault(_version);

var _setupStyledComponents = require('../listeners/setupStyledComponents');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIApplication = function (_React$Component) {
  _inherits(UIApplication, _React$Component);

  function UIApplication(props) {
    _classCallCheck(this, UIApplication);

    var _this = _possibleConstructorReturn(this, (UIApplication.__proto__ || Object.getPrototypeOf(UIApplication)).call(this, props));

    (0, _setupStyledComponents.setupStyledComponents)();
    return _this;
  }

  _createClass(UIApplication, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        I18n: this.props.I18n,
        usageTracker: this.props.usageTracker
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bodyClassName = _props.bodyClassName,
          className = _props.className,
          __I18n = _props.I18n,
          __usageTracker = _props.usageTracker,
          TagName = _props.tagName,
          _bodyElement = _props._bodyElement,
          rest = _objectWithoutProperties(_props, ['bodyClassName', 'className', 'I18n', 'usageTracker', 'tagName', '_bodyElement']);

      var classes = (0, _reactUtils.classNames)('ui-app', 'ui-app-v' + _version2.default, bodyClassName);

      return _react2.default.createElement(
        _ComponentWithBodyClass2.default,
        {
          bodyClassName: classes,
          bodyElement: _bodyElement
        },
        _react2.default.createElement(TagName, _extends({
          className: (0, _reactUtils.classNames)('private-application', className)
        }, rest))
      );
    }
  }]);

  return UIApplication;
}(_react2.default.Component);

UIApplication.propTypes = {
  _bodyElement: _react.PropTypes.object,
  bodyClassName: _react.PropTypes.string,
  className: _react.PropTypes.string,
  I18n: _react.PropTypes.object,
  name: _react.PropTypes.string.isRequired,
  tagName: _react.PropTypes.string,
  usageTracker: _Trackable.usageTrackerPropType
};

UIApplication.defaultProps = {
  tagName: 'div'
};

UIApplication.childContextTypes = {
  I18n: _react.PropTypes.object,
  usageTracker: _Trackable.usageTrackerPropType
};

exports.default = UIApplication;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/app/UIApplication.js
// module id = 145
// module chunks = 0